import React from 'react';
import { FadeIn } from './ui/FadeIn';
const testimonials = [{
  quote: 'Pegué la Fórmula 30/40/30 en el manubrio y llegué a la cima con el grupo por primera vez en años. No me lo esperaba tan rápido.',
  name: 'Fernando T.',
  desc: '📍 Tucumán | PROTORRENDA 4-12 completo'
}, {
  quote: 'El Tomo 5 de biomecánica me eliminó el dolor de rodilla que tenía hace 2 años. En la primera salida después de ajustar ya sentí la diferencia.',
  name: 'Diego R.',
  desc: '📍 Mendoza | Ciclista amateur'
}, {
  quote: 'Con la bitácora me di cuenta que estaba acumulando cansancio sin adaptación. Ahora por primera vez veo mi progreso semana a semana.',
  name: 'Gustavo M.',
  desc: '📍 Rosario | Ciclista amateur'
}];
export function TestimonialsSection() {
  return <section className="py-12 md:py-16 px-4 bg-slate-900 border-y border-slate-800/50" data-id="element-346">
      <div className="max-w-4xl mx-auto" data-id="element-347">
        <FadeIn data-id="element-348">
          <h2 className="text-amber-500 font-black tracking-widest uppercase text-sm mb-8 text-center" data-id="element-349">
            ❤️ MÁS CICLISTAS QUE YA LO APLICAN
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-350">
          {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-351">
              <div className="bg-slate-950 border border-slate-800 rounded-2xl p-6 md:p-8 relative" data-id="element-352">
                <div className="absolute top-6 right-6 text-6xl text-slate-800 font-serif leading-none opacity-50" data-id="element-353">
                  "
                </div>
                <div className="flex gap-1 mb-4 relative z-10" data-id="element-354">
                  {[...Array(5)].map((_, i) => <span key={i} className="text-amber-500 text-lg" data-id="element-355">
                      ⭐
                    </span>)}
                </div>
                <p className="text-slate-300 italic mb-6 relative z-10 text-lg" data-id="element-356">
                  "{t.quote}"
                </p>
                <div className="flex items-center gap-3 relative z-10" data-id="element-357">
                  <div data-id="element-358">
                    <p className="text-white font-bold text-sm" data-id="element-359">{t.name}</p>
                    <p className="text-slate-500 text-xs" data-id="element-360">{t.desc}</p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}